import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import globalReducer from "./reducers/globalReducer";
import widgetsReducer from "./reducers/widgetsReducer";
import deepDiveReducer from "./reducers/deepDiveReducer";
import postsFeedReducer from "./reducers/postsFeedReducer";
import mobileReducer from "./reducers/mobileReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    combineReducers({ globalReducer, widgetsReducer, deepDiveReducer, postsFeedReducer, mobileReducer }),
    composeEnhancers(applyMiddleware(thunk, promise))
);
